import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { catalogModule } from './modules/catalog';
import { vaultModule } from './modules/vault';
import { accountsModule } from './modules/accounts';

export default createApp({
  features: [
    catalogPlugin,
    catalogModule,
    vaultModule,
    accountsModule,
    navModule,
  ],
});
